import { SET_SUPPRESS_PON_ACTION } from '../actions/actionTypes'
import objectPath from 'object-path';
function addItemToArray(stringArray: string[], item: string): string[]{
    if(stringArray === undefined){
        stringArray = [item];
    }
    else if(!stringArray.includes(item)){
        stringArray.push(item);
    }

    return stringArray;
}
export default function reduce(state = {}, action: any): {} {
    let newState;
    switch(action.type)
    {
        case SET_SUPPRESS_PON_ACTION:
            newState = Object.assign({}, state);
            let suppressAction = newState.SuppressAction;
            suppressAction = addItemToArray(suppressAction, action.payload.value);
            objectPath.set(newState, "SuppressAction", suppressAction);
            return newState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/response-handler-launch-message-process/reducers/index.ts